// Internal Dependencies
import { fetchCoderSingleAction } from './action-creator';
import { firebaseRef } from '../../config/constants';

// Action Defintions
export const fetchCoderSingle = (coderKey) => {
  const CoderSingle = firebaseRef.child('coders').child(coderKey);
  return (dispatch) => {
    CoderSingle.on('value', (snapshot) => {
      dispatch(fetchCoderSingleAction(snapshot.val()));
    });
  };
};

export default {
  fetchCoderSingle,
};



/** WEBPACK FOOTER **
 ** ./src/state/actions/coder-single-actions.js
 **/